<div class="mb-5">
	<div class="d-flex justify-content-between align-items-center">
		<div class="d-flex justify-content-between align-items-center">
			<h1 class="h3 m-4">{{'utilization.relative_truck_utilization' | translate}}</h1>
			<app-help-tooltip [field]="'relative_truck_utilization'"></app-help-tooltip>
		</div>

		<div class="d-inline-flex ml-auto">
				<button style="font-size: 20px;" class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportCsv()"></button>
		</div>
	</div>
	<div class="widget-container">
		<div class="filter-container row col-12 mb-4">
			<!-- period filter -->
			<div class="col-sm-6 col-md-3 col-lg-3">
				<label for="periodSelect">{{"rt_history.periods" | translate}}</label>
				<ng-select
					id="periodSelect"
					class="select"
					[items]="periods"
					[addTag]="false"
					[clearable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="onSelectionChanged({filter: 'period', value: $event.value})"
					[placeholder]="'g.durations' | translate"
					[(ngModel)]="selectedPeriod"
				></ng-select>
			</div>

			<!-- truck type filter -->
			<div class="col-sm-6 col-md-3 col-lg-3">
				<label for="truckTypeSelect">{{"exception_reports.truck_types" | translate}}</label>
				<ng-select
					class="select"
					[items]="truckTypes"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="onSelectionChanged({filter: 'truckType', value: $event.value})"
					[placeholder]="'g.type' | translate"
					[(ngModel)]="selectedTruckType"
				></ng-select>
			</div>

			<!-- chart type filter -->
			<div class="col-sm-6 col-md-3 col-lg-3">
				<label for="chartTypeSelect">{{"g.chart_type" | translate}}</label>
				<ng-select
					id="chartTypeSelect"
					class="select"
					[items]="chartTypes"
					[addTag]="false"
					[clearable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="onSelectionChanged({filter: 'chartType', value: $event.value})"
					[placeholder]="'g.type' | translate"
					[(ngModel)]="selectedChartType"
				></ng-select>
			</div>

			<!-- chart criteria filter -->
			<div class="col-sm-6 col-md-3 col-lg-3">
				<label for="chartCriteriaSelect">{{"g.chart_criteria" | translate}}</label>
				<ng-select
					id="chartCriteriaSelect"
					class="select"
					[items]="chartCriteria"
					[addTag]="false"
					[clearable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="onSelectionChanged({filter: 'chartCriteria', value: $event.value})"
					[placeholder]="'g.criteria' | translate"
					[(ngModel)]="selectedChartCriteria"
				></ng-select>
			</div>
		</div>

		<div class="filter-container row col-12 mb-4">
			<!-- from and to filters -->
			<div class="col-sm-6 col-md-3 col-lg-3" *ngIf="selectedPeriod === 'custom'">
				<label for="customDateRange">{{'g.from_date' | translate}}</label>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text">{{'g.start_date' | translate}}</span>
					</div>
					<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp1" (ngModelChange)="changeDate('fromDate', $event)" [(ngModel)]="fromDate" bsDatepicker #d1="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [maxDate]="toDate" [minDate]="siteInstallationDate">
					<div class="input-group-append pointer" (click)="d1.toggle()">
						<span class="input-group-text"><i class="fa fa-calendar"></i></span>
					</div>
				</div>
			</div>

			<div class="col-sm-6 col-md-3 col-lg-3" *ngIf="selectedPeriod === 'custom'">
				<label for="customDateRange">{{'g.to_date' | translate}}</label>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text">{{'g.end_date' | translate}}</span>
					</div>
					<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp2" (ngModelChange)="changeDate('toDate', $event)" [(ngModel)]="toDate" bsDatepicker #d2="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [minDate]="fromDate">
					<div class="input-group-append pointer" (click)="d2.toggle()">
						<span class="input-group-text"><i class="fa fa-calendar"></i></span>
					</div>
				</div>
			</div>

			<!-- Manufacturer filter -->
			<div class="col-sm-6 col-md-3 col-lg-3">
				<label for="workingDaysSelect">{{"devices.truck_manufacturer" | translate}}</label>
				<ng-select
					class="select"
					[items]="truckManufacturer"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="onSelectionChanged({filter: 'truckManufacturer', value: $event.value})"
					[placeholder]="'g.durations' | translate"
					[(ngModel)]="selectedtruckManufacturer"
				></ng-select>
			</div>

			<!-- Vintage filter -->
			<div class="col-xl-3 col-md-3">
				<label for="batteryVintageSelect">{{"devices.truck_vintage" | translate}}</label>
				<ng-select
					name="batteryVintageSelect"
					id="batteryVintageSelect"
					class="select"
					[multiple]="true"
					[items]="vintageOptionsDropdown"
					[addTag]="true"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					[placeholder]="'devices.truck_vintage' | translate"
					[(ngModel)]="selectedBatteryVintage"
					(change)="batteryVintageSelectionChanged()"
				>
					<ng-template ng-label-tmp let-item="item" let-clear="clear">
						<span>
							<span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
							<span class="ng-value-label">{{item.label}}</span>
						</span>
					</ng-template>
				</ng-select>
			</div>
		</div>

		<sct-charts
			*ngIf="showChart; else noData"
			class="chart"
			[id]="chart.title"
			[title]="chart.title"
			[data]="chart.data"
			[columnNames]="chart.columnNames"
			[options]="chart.config"
			[type]="'ColumnChart'"
		></sct-charts>
		<div class="row">
			<div class="buttons-container d-flex justify-content-between align-items-center mt-2" *ngIf="devicesCount > pageSize">
				<button class="btn btn-primary" (click)="prevPage()" [disabled]="currentPage === 0">{{'g.previous' | translate}}</button>
				<button class="btn btn-primary" (click)="nextPage()" [disabled]="isLastPage()">{{'g.next' | translate}}</button>
			</div>
		</div>
	</div>
</div>

<ng-template #noData class="mt-4">
	<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>
